import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


import { compose } from 'redux';

class PhotographyContent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }

    render() {
        return (
            <section className="mole__credits--content fullW">
                <div className="main-container">
                    <div className="inner-container">
                        <h6 className="font-lg">Credits</h6>


                        <div className="credits--list">
                            <article>
                                <p><a href="javascript:" target="_blank">Siobhan Doran</a></p>
                                <p>Cavendish</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">John Donat</a></p>
                                <p>The Black House</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Matt Smith</a></p>
                                <p>Mill Lane <br/>Cavendish</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Ray Main</a></p>
                                <p>The Black House</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Matt Smith</a></p>
                                <p>Mill Lane</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">John Donat</a></p>
                                <p>The Black House</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Ray Main</a></p>
                                <p>The Black House</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Matt Smith</a></p>
                                <p>Mill Lane</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">Siobhan Doran</a></p>
                                <p>Cavendish</p>
                            </article>

                            <article>
                                <p><a href="javascript:" target="_blank">John Donat</a></p>
                                <p>The Black House</p>
                            </article>
                            <article>
                                <p><a href="javascript:" target="_blank">Siobhan Doran</a></p>
                                <p>Cavendish</p>
                            </article>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default PhotographyContent;



// WEBPACK FOOTER //
// ./src/components/Credits/Photography/PhotographyContent.js